import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Col, ContainerFluid, Row } from '@navent-jobs/ui-kit/components/grid'
import { Modal } from '@navent-jobs/ui-kit/components/modal'
import Text from '@navent-jobs/ui-kit/components/text'
import { numberTropicalizer } from '@navent-jobs/config'
import Billetera from '../../../../../../../../../assets/images/billetera.svg'
import {
  Amounts,
  CustomButton,
  CustomImage,
  DataContainer,
  Divider,
  FooterContent,
  ModalContainer,
  Title,
  CustomRow,
} from './mixins'
import { NOMBRE_PAIS } from '../../../../../../../../../constants'

const ModalFooter = ({ onCancel, isLoading }) => {
  return (
    <ContainerFluid>
      <Row>
        <Col>
          <FooterContent>
            <CustomButton buttonoptions={{ variant: 'primary', size: 'medium', type: 'link' }} onClick={onCancel}>
              Volver al aviso
            </CustomButton>

            <CustomButton
              buttonoptions={{ variant: 'primary', size: 'medium' }}
              form="form-salario-pretendido"
              type="submit"
              isLoading={isLoading}
              disabled={isLoading}
            >
              Postularme
            </CustomButton>
          </FooterContent>
        </Col>
      </Row>
    </ContainerFluid>
  )
}

const ModalCalculadora = ({ visible, closeModal, isLoading, calculadora }) => {
  const { t } = useTranslation()

  return (
    <Modal
      width={800}
      visible={visible}
      onClose={closeModal}
      footer={<ModalFooter onCancel={closeModal} isLoading={isLoading} />}
      title={
        <Title>
          <Text type="title" size="xs" fontWeight="semibold" variant="secondary" as="h3">
            {t('fichaAviso.calculadoraSalario.modal.title')}
          </Text>
        </Title>
      }
    >
      <ContainerFluid>
        <Row>
          <Col>
            <ModalContainer>
              <CustomImage src={Billetera} width="180px" alt="Imagen billetera" />
              <DataContainer>
                <CustomRow noGutter>
                  <Col xs={8}>
                    <Text size="md" fontWeight="semibold">
                      {t('fichaAviso.calculadoraSalario.modal.sueldoBrutoLabel')}
                    </Text>
                  </Col>
                  <Col xs={4}>
                    <Amounts>
                      <Text size="md" fontWeight="semibold">{`${t('currencyMask.symbol')}${
                        numberTropicalizer(calculadora?.salario?.salarioBruto) || 0
                      }`}</Text>
                    </Amounts>
                  </Col>
                </CustomRow>
                {calculadora?.salario &&
                  calculadora.salario.impuestos?.map(impuesto => (
                    <CustomRow noGutter key={`impuesto-${impuesto.nombre}`}>
                      <Col xs={8}>
                        <Text size="md">{`${impuesto.nombre} (${impuesto.porcentaje}%)`}</Text>
                      </Col>
                      <Col xs={4}>
                        <Amounts>
                          <Text size="md">{`${t('currencyMask.symbol')}${
                            numberTropicalizer(impuesto.monto) || 0
                          }`}</Text>
                        </Amounts>
                      </Col>
                    </CustomRow>
                  ))}
                <CustomRow noGutter>
                  <Col xs={8}>
                    <Text size="md" fontWeight="semibold">
                      {t('fichaAviso.calculadoraSalario.modal.sueldoNetoLabel')}
                    </Text>
                  </Col>
                  <Col xs={4}>
                    <Amounts>
                      <Text size="md" fontWeight="semibold">{`${t('currencyMask.symbol')}${
                        numberTropicalizer(calculadora?.salario?.salarioNeto) || 0
                      }`}</Text>
                    </Amounts>
                  </Col>
                </CustomRow>
                <Divider />
              </DataContainer>
              <Text size="md">
                <Trans
                  i18nKey="fichaAviso.calculadoraSalario.modal.description"
                  components={[
                    <Text size="md" fontWeight="semibold" as="span">
                      <></>
                    </Text>,
                  ]}
                  values={{ pais: NOMBRE_PAIS }}
                />
                {t('fichaAviso.calculadoraSalario.modal.impuestos')}
              </Text>
            </ModalContainer>
          </Col>
        </Row>
      </ContainerFluid>
    </Modal>
  )
}

export default ModalCalculadora
